import { useAdminDetails } from "@/v2/stores";

interface UsePreviewModeReturn {
  isPreviewMode: boolean;
  previewRole: string | null;
  previewWhitelabel: string | null;
  effectiveIsSuperAdmin: boolean;
  effectiveIsCityAdmin: boolean;
  exitPreviewMode: () => void;
}

export const usePreviewMode = (): UsePreviewModeReturn => {
  const adminDetails = useAdminDetails();
  const actualIsSuperAdmin =
    adminDetails?.cityId === null && adminDetails?.whiteLabelId === null;

  if (!actualIsSuperAdmin) {
    return {
      isPreviewMode: false,
      previewRole: null,
      previewWhitelabel: null,
      effectiveIsSuperAdmin: actualIsSuperAdmin,
      effectiveIsCityAdmin: adminDetails?.cityId === null,
      exitPreviewMode: () => {},
    };
  }

  let previewRole: string | null = null;
  let previewWhitelabel: string | null = null;
  try {
    const storedRole = localStorage.getItem("previewRole");
    const storedWhitelabel = localStorage.getItem("whitelabelName");
    previewRole = storedRole ? JSON.parse(storedRole) : null;
    previewWhitelabel = storedWhitelabel ? JSON.parse(storedWhitelabel) : null;
  } catch {
    // Ignore parse errors
  }

  const exitPreviewMode = () => {
    localStorage.removeItem("previewRole");
    localStorage.removeItem("whitelabelName");
    try {
      const persistedCities = localStorage.getItem("persist:cities");
      if (persistedCities) {
        const citiesState = JSON.parse(persistedCities);
        citiesState.savedCity = null;
        citiesState.savedCityFullInfo = null;
        localStorage.setItem("persist:cities", JSON.stringify(citiesState));
      }
    } catch {
      // Ignore storage errors
    }
    window.location.reload();
  };

  const effectiveIsSuperAdmin = !previewRole || previewRole === "super_admin";
  const effectiveIsCityAdmin =
    !previewRole ||
    previewRole === "super_admin" ||
    previewRole === "whitelabel_admin";

  const isWhitelabelChanged =
    previewWhitelabel && previewWhitelabel !== "sharebike";
  const isRoleChanged = previewRole && previewRole !== "super_admin";
  const isPreviewMode = Boolean(isRoleChanged || isWhitelabelChanged);

  return {
    isPreviewMode,
    previewRole,
    previewWhitelabel,
    effectiveIsSuperAdmin,
    effectiveIsCityAdmin,
    exitPreviewMode,
  };
};
